﻿import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';


import { User } from '../_models';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string) {

        return this.http.post<any>('/rest-api/signin',
            { 'username': username, 'password': password })
            .pipe(
                map(
                    data => {
                        const user = new User();
                        user.email = data.email;
                        user.firstName = data.firstName;
                        user.lastName = data.lastName;
                        user.roles = data.roles;
                        user.token = data.token;
                        user.tipo = data.tipo;
                        user.tokenExpired = data.tokenExpired;
                        localStorage.setItem('user', JSON.stringify(user));
                        this.currentUserSubject.next(user);
                        return true;
                    })
            );

    }

    getUserLogin(token: string) {

        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': `Bearer ` + token
            })
        };

        return this.http.get<any>('/rest-api/user', httpOptions)
            .pipe(
                map(
                    data => {
                        const user = new User();
                        user.email = data.email;
                        user.firstName = data.firstName;
                        user.lastName = data.lastName;
                        user.roles = data.roles;
                        user.token = data.token;
                        user.tipo = data.tipo;
                        user.tokenExpired = data.tokenExpired;
                        localStorage.setItem('user', JSON.stringify(user));
                        this.currentUserSubject.next(user);
                        return true;
                    })
            );

    }

    changePass(username: string, password: string) {

        return this.http.post<any>('/rest-api/change',
            { 'username': username, 'password': password })
            .pipe(
                map(
                    data => {
                        const user = this.currentUserValue
                        user.tokenExpired = false;
                        localStorage.setItem('user', JSON.stringify(user));
                        this.currentUserSubject.next(user);
                        return true;
                    })
            );

    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('user');
        this.currentUserSubject.next(null);
    }

    hasRol(rolName: string): boolean {
        if (this.currentUserValue) {
            let encontro: boolean = false;
            this.currentUserValue.roles.forEach(rol => {
                if (rolName === rol) {
                    encontro = true;
                }
            });
            return encontro;
        } else {
            return false;
        }
    }

    refresh() {
        return this.http.post<any>('/rest-api/refresh', this.currentUserValue.token)
            .pipe(
                map(
                    data => {
                        const user = this.currentUserValue
                        user.token = data.token;
                        localStorage.setItem('user', JSON.stringify(user));
                        this.currentUserSubject.next(user);
                        return data.token;
                    })
            );

    }
}
